import React from 'react';
import ReactDOM from 'react-dom/client';
import { $Number, $NumberArray, $String, $StringArray, persistToLocalStorage } from '@sasha.p/use-persistent-state';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';

import './index.css';

(function migrateLocalStorage() {
    const key = 'settings';

    if (parse(localStorage.getItem(key) ?? '') === '') {
        console.log('There is no settings, need to migrate');

        // Mapping old keys to new keys
        const migrations = {
            solInitialBuyArrow: 'solInitialBuyArrow',
            solInitialBuyCopy: 'solInitialBuyCopy',
            ethLiquidityArrow: 'ethLiquidityArrow',
            ethLiquidityCopy: 'ethLiquidityCopy',
            solSnipeArrow: 'solSnipeArrow',
            solSnipeCopy: 'solSnipeCopy',
            ethSnipeValues: 'ethSnipeValues',
            buyPrio: 'solBuyPrio',
            sellPrio: 'solSellPrio',
            autoSellDelayArrow: 'autoSellDelayArrow',
            autoSellProfitArrow: 'autoSellProfitArrow',
            autoSellDelayCreation: 'autoSellDelayCreation',
            autoSellProfitCreation: 'autoSellProfitCreation',
            ethPrivateKey: 'ethPrivateKey',
            solanaPrivateKey: 'solanaPrivateKey',
            solanaSniperPrivateKey: 'solanaSniperPrivateKey',
            ethSniperPrivateKeys: 'ethSniperPrivateKeys',
            zeroSlotSellTip: 'zeroSlotSellTip',
            zeroSlotBuyTip: 'zeroSlotBuyTip',
            solRpcUrl: 'solRpcUrl',
            ethRpcUrl: 'ethRpcUrl',
        } as const;

        const values = Object.keys(migrations).reduce((acc, oldKey) => {
            const newKey = migrations[oldKey as keyof typeof migrations];
            const stored = localStorage.getItem(oldKey);
            const value = stored ? parse(stored) : undefined;

            return {
                ...acc,
                [newKey]: value,
            };
        }, {});

        persistToLocalStorage(
            {
                solInitialBuyArrow: $Number({ defaultValue: 3 }),
                solInitialBuyCopy: $Number({ defaultValue: 3 }),
                ethLiquidityArrow: $Number({ defaultValue: 3 }),
                ethLiquidityCopy: $Number({ defaultValue: 3 }),
                solSnipeArrow: $Number({ defaultValue: 3 }),
                solSnipeCopy: $Number({ defaultValue: 3 }),
                ethSnipeValues: $NumberArray({ defaultValue: [] }),
                solBuyPrio: $Number({ defaultValue: 4000000 }),
                solSellPrio: $Number({ defaultValue: 4000000 }),
                autoSellDelayArrow: $Number({ defaultValue: 10 }),
                autoSellDelayCreation: $Number({ defaultValue: 10 }),
                autoSellProfitArrow: $Number({ defaultValue: 50 }),
                autoSellProfitCreation: $Number({ defaultValue: 50 }),
                ethPrivateKey: $String({ defaultValue: '' }),
                solanaPrivateKey: $String({ defaultValue: '' }),
                solanaSniperPrivateKey: $String({ defaultValue: '' }),
                ethSniperPrivateKeys: $StringArray({ defaultValue: [] }),
                zeroSlotBuyTip: $Number({ defaultValue: 0.00011 }),
                zeroSlotSellTip: $Number({ defaultValue: 0.00011 }),
                solRpcUrl: $String({ defaultValue: 'https://ofelia-3bh1h8-fast-mainnet.helius-rpc.com' }),
                ethRpcUrl: $String({ defaultValue: 'https://small-holy-dew.quiknode.pro/fbe4e898c2491573e0ef6d4928ec8c150377eefe' }),
            },
            values,
            { key },
        );
    } else {
        console.log('Settings are present, no need to migrate');
    }

    console.log('LocalStorage migration completed ✅');

    function parse(str: string) {
        try {
            return JSON.parse(str);
        } catch {
            return str;
        }
    }
})();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <Router>
            <App />
        </Router>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
